import React from 'react';

import ConnectSvg from 'assets/images/connect.svg';

import BaseIcon from './BaseIcon';

const ConnectIcon = props => <BaseIcon {...props} src={ConnectSvg} />;

export default ConnectIcon;
